import React, { useState, useEffect } from 'react';
import { Select, Checkbox, Form } from 'antd';
import TriangleDownIcon from '@web-common/components/UI/Icons/svgs/TriangleDown';
import TagCloseIcon from '@web-common/components/UI/Icons/svgs/TagCloseSvg';
import styles from './applyAction.module.scss';
import { getIn18Text } from 'api';
const CheckboxGroup = Checkbox.Group;
export const ApplyAction = props => {
    const { form, operand, optionsList, _account } = props;
    const [selectOpen, setSelectOpen] = useState(false);
    const [checkAll, setCheckAll] = useState(false);
    const [defaultOperand, setDefaultOperand] = useState([]);
    const [indeterminate, setIndeterminate] = useState(true);
    useEffect(() => {
        if (operand.length === 0 || operand.length === optionsList.length) {
            setCheckAll(true);
            setIndeterminate(false);
            setDefaultOperand(optionsList);
            form.setFieldsValue({ accounts: optionsList });
        }
        else {
            setDefaultOperand(operand);
            form.setFieldsValue({ accounts: operand });
            setIndeterminate(true);
            setCheckAll(false);
        }
    }, [operand, optionsList]);
    const onChange = list => {
        setDefaultOperand(list);
        setIndeterminate(!!list.length && list.length < optionsList.length);
        form.setFieldsValue({ accounts: list });
        setCheckAll(list.length === optionsList.length);
    };
    const onCheck = e => {
        const { checked } = e.target;
        setCheckAll(checked);
        setIndeterminate(false);
        setDefaultOperand(checked ? optionsList : []);
        form.setFieldsValue({
            accounts: checked ? optionsList : [],
        });
    };
    return (React.createElement("div", { className: styles.classifyApply },
        React.createElement("span", { className: styles.classifyApplyTitle }, getIn18Text('GUIZESHIYONGZHANG')),
        React.createElement(Form.Item, { name: "accounts", initialValue: defaultOperand, rules: [{ required: true, message: getIn18Text('QINGXUANZE') }] },
            React.createElement(Select, { placeholder: getIn18Text('XUANZEGUIZESHI'), className: styles.classifyApplySelect, style: { width: '100%' }, open: selectOpen, mode: "multiple", allowClear: true, onDropdownVisibleChange: setSelectOpen, maxTagCount: 'responsive', showArrow: true, suffixIcon: React.createElement(TriangleDownIcon, { className: "dark-invert" }), removeIcon: React.createElement(TagCloseIcon, { className: "dark-invert" }), onChange: onChange, dropdownRender: menu => (React.createElement(React.Fragment, null,
                    React.createElement(Checkbox, Object.assign({ className: styles.classifyApplyCheckbox }, (!checkAll && { indeterminate }), { onChange: onCheck, checked: checkAll }), defaultOperand.length === 0 ? getIn18Text('QUANXUAN') : `已选(${defaultOperand.length})`),
                    React.createElement(CheckboxGroup, { className: styles.classifyApplyCheckGroup, options: optionsList, value: defaultOperand, onChange: onChange }))), getPopupContainer: node => node.parentElement }))));
};
